import { SET_CACHE, CLEAR_CACHE, CLEAR_PAGE_CACHE } from '@/store/mutation-types'

const state = {
  widgets: {},
  pages: {},
  events: {}
}

const getters = {
  widgets: (state) => (url) => state.widgets[url],
  pages: (state) => (url) => state.pages[url],
  events: (state) => (url) => state.events[url]
}

const mutations = {
  [SET_CACHE] (state, { type, url, results }) {
    state[type][url] = results
  },
  [CLEAR_CACHE] (state, type) {
    state[type] = {}
  },
  [CLEAR_PAGE_CACHE] (state, url) {
    delete state.pages[url]
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
